// src/data/translations.js
// Semua text UI dalam 4 bahasa. Nama style & prompt kekal English.
// Guna {n}, {left}, {limit}, {search} sebagai placeholder — diganti dalam code.

export const LANGUAGES = [
  { code: "en", label: "English",          short: "EN", flag: "🇬🇧" },
  { code: "ms", label: "Bahasa Malaysia",  short: "BM", flag: "🇲🇾" },
  { code: "zh", label: "中文",              short: "中",  flag: "🇨🇳" },
  { code: "ta", label: "தமிழ்",            short: "த",  flag: "🇮🇳" },
];

export const TRANSLATIONS = {
  // ─────────────────────────── ENGLISH ───────────────────────────
  en: {
    hero_badge: "Click · Auto Copy · Paste Anywhere",
    hero_title_1: "Pick a style.",
    hero_title_2: "Prompt copied instantly.",
    hero_subtitle: "Click any style — prompt auto-copied to clipboard. Paste into Gemini, ChatGPT, or any AI with your photo.",
    search_placeholder: "Search styles...",
    styles_available: "{n} styles available",
    click_to_copy: "Click to copy prompt",
    login_to_copy: "Login to copy",
    no_styles: 'No styles found for "{search}"',
    how_to_use: "How to use",
    step_label: "STEP",
    step1_title: "Sign in",          step1_desc: "Log in with your Google account to get started",
    step2_title: "Pick a style",     step2_desc: "Browse and find the art style you want",
    step3_title: "Click — auto copy", step3_desc: "Prompt is instantly copied to your clipboard",
    step4_title: "Upload & Paste",   step4_desc: "Upload your photo and paste into any AI tool",
    counter_left: "{left} / {limit} left",
    upgrade_arrow: "Upgrade →",
    modal_title: "Get More Prompts",
    modal_subtitle: "One-time payment. No subscription. No expiry.",
    tier_starter: "Starter",
    tier_popular: "Popular",
    tier_lifetime: "Lifetime",
    starter_value: "20 prompts",
    popular_value: "100 prompts",
    lifetime_value: "∞ Unlimited prompts",
    valid_30days: "Valid for 30 days",
    lifetime_sub: "Never expires · One-time only",
    one_time: "one-time",
    forever: "forever",
    badge_popular: "MOST POPULAR",
    badge_best: "BEST VALUE",
    modal_note: "Unlock your creativity. Use prompts anytime, transform any photo into stunning art.",
    maybe_later: "Maybe later",
    login_first: "Please log in first to copy prompts.",
    suggest_title: "Suggest a Style",
    suggest_desc: "Want a style we don't have yet? Tell us — we add new styles based on your ideas.",
    suggest_placeholder: "e.g. Add a 'Cartoon Caricature' style, or any feedback...",
    suggest_send: "Send Suggestion",
    suggest_sending: "Sending...",
    suggest_success: "✓ Thank you! Your suggestion has been sent.",
    suggest_login: "Please log in to send a suggestion.",
    suggest_error: "Something went wrong. Please try again.",
    cat_all: "All", cat_comic: "Comic", cat_cute: "Cute", cat_animation: "Animation",
    cat_traditional: "Traditional", cat_digital: "Digital", cat_retro: "Retro",
    cat_art: "Art", cat_minimal: "Minimal",
    orient_default: "Default",
    orient_landscape: "Landscape (16:9)",
    orient_portrait: "Portrait (9:16)",
    copied_title: "✓ Prompt copied!",
    copied_desc: "Now open an AI tool and upload your photo:",
    copied_tip: "Tip: Upload your photo first, then paste the copied prompt.",
  },

  // ─────────────────────────── BAHASA MALAYSIA ───────────────────────────
  ms: {
    hero_badge: "Klik · Auto Salin · Tampal Di Mana-mana",
    hero_title_1: "Pilih satu gaya.",
    hero_title_2: "Prompt disalin serta-merta.",
    hero_subtitle: "Klik mana-mana gaya — prompt auto-disalin ke papan keratan. Tampal ke dalam Gemini, ChatGPT, atau mana-mana AI bersama gambar anda.",
    search_placeholder: "Cari gaya...",
    styles_available: "{n} gaya tersedia",
    click_to_copy: "Klik untuk salin prompt",
    login_to_copy: "Log masuk untuk salin",
    no_styles: 'Tiada gaya dijumpai untuk "{search}"',
    how_to_use: "Cara guna",
    step_label: "LANGKAH",
    step1_title: "Log masuk",        step1_desc: "Log masuk dengan akaun Google anda untuk bermula",
    step2_title: "Pilih gaya",       step2_desc: "Layari dan cari gaya seni yang anda mahu",
    step3_title: "Klik — auto salin", step3_desc: "Prompt serta-merta disalin ke papan keratan anda",
    step4_title: "Muat naik & Tampal", step4_desc: "Muat naik gambar anda dan tampal ke mana-mana alat AI",
    counter_left: "{left} / {limit} baki",
    upgrade_arrow: "Naik taraf →",
    modal_title: "Dapatkan Lebih Banyak Prompt",
    modal_subtitle: "Bayaran sekali sahaja. Tiada langganan. Tiada tamat tempoh.",
    tier_starter: "Starter",
    tier_popular: "Popular",
    tier_lifetime: "Lifetime",
    starter_value: "20 prompt",
    popular_value: "100 prompt",
    lifetime_value: "∞ Prompt tanpa had",
    valid_30days: "Sah selama 30 hari",
    lifetime_sub: "Tidak tamat tempoh · Sekali bayar sahaja",
    one_time: "sekali bayar",
    forever: "selamanya",
    badge_popular: "PALING POPULAR",
    badge_best: "NILAI TERBAIK",
    modal_note: "Bebaskan kreativiti anda. Guna prompt bila-bila masa, ubah mana-mana gambar menjadi seni menakjubkan.",
    maybe_later: "Lain kali",
    login_first: "Sila log masuk dahulu untuk menyalin prompt.",
    suggest_title: "Cadangkan Gaya",
    suggest_desc: "Mahukan gaya yang kami belum ada? Beritahu kami — kami tambah gaya baharu berdasarkan idea anda.",
    suggest_placeholder: "cth. Tambah gaya 'Karikatur Kartun', atau apa-apa maklum balas...",
    suggest_send: "Hantar Cadangan",
    suggest_sending: "Menghantar...",
    suggest_success: "✓ Terima kasih! Cadangan anda telah dihantar.",
    suggest_login: "Sila log masuk untuk menghantar cadangan.",
    suggest_error: "Ada yang tidak kena. Sila cuba lagi.",
    cat_all: "Semua", cat_comic: "Komik", cat_cute: "Comel", cat_animation: "Animasi",
    cat_traditional: "Tradisional", cat_digital: "Digital", cat_retro: "Retro",
    cat_art: "Seni", cat_minimal: "Minimal",
    orient_default: "Lalai",
    orient_landscape: "Landskap (16:9)",
    orient_portrait: "Potret (9:16)",
    copied_title: "✓ Prompt disalin!",
    copied_desc: "Buka alat AI dan muat naik gambar anda:",
    copied_tip: "Tips: Muat naik gambar anda dahulu, kemudian tampal prompt yang disalin.",
  },

  // ─────────────────────────── 中文 (SIMPLIFIED) ───────────────────────────
  zh: {
    hero_badge: "点击 · 自动复制 · 随处粘贴",
    hero_title_1: "选择一个风格。",
    hero_title_2: "提示词即时复制。",
    hero_subtitle: "点击任何风格 — 提示词自动复制到剪贴板。粘贴到 Gemini、ChatGPT 或任何 AI 工具，连同您的照片一起使用。",
    search_placeholder: "搜索风格...",
    styles_available: "{n} 个风格可用",
    click_to_copy: "点击复制提示词",
    login_to_copy: "登录以复制",
    no_styles: '找不到 "{search}" 的风格',
    how_to_use: "使用方法",
    step_label: "步骤",
    step1_title: "登录",        step1_desc: "使用您的 Google 账户登录以开始",
    step2_title: "选择风格",     step2_desc: "浏览并找到您想要的艺术风格",
    step3_title: "点击 — 自动复制", step3_desc: "提示词即时复制到您的剪贴板",
    step4_title: "上传并粘贴",   step4_desc: "上传您的照片并粘贴到任何 AI 工具",
    counter_left: "剩余 {left} / {limit}",
    upgrade_arrow: "升级 →",
    modal_title: "获取更多提示词",
    modal_subtitle: "一次性付款。无需订阅。永不过期。",
    tier_starter: "入门",
    tier_popular: "热门",
    tier_lifetime: "终身",
    starter_value: "20 个提示词",
    popular_value: "100 个提示词",
    lifetime_value: "∞ 无限提示词",
    valid_30days: "有效期 30 天",
    lifetime_sub: "永不过期 · 仅需一次付款",
    one_time: "一次性",
    forever: "永久",
    badge_popular: "最受欢迎",
    badge_best: "超值之选",
    modal_note: "释放您的创意。随时使用提示词，将任何照片转化为精美艺术作品。",
    maybe_later: "稍后再说",
    login_first: "请先登录以复制提示词。",
    suggest_title: "建议风格",
    suggest_desc: "想要我们还没有的风格吗？告诉我们 — 我们会根据您的想法添加新风格。",
    suggest_placeholder: "例如：添加'卡通漫画'风格，或任何反馈...",
    suggest_send: "发送建议",
    suggest_sending: "发送中...",
    suggest_success: "✓ 谢谢！您的建议已发送。",
    suggest_login: "请登录以发送建议。",
    suggest_error: "出了点问题。请重试。",
    cat_all: "全部", cat_comic: "漫画", cat_cute: "可爱", cat_animation: "动画",
    cat_traditional: "传统", cat_digital: "数码", cat_retro: "复古",
    cat_art: "艺术", cat_minimal: "简约",
    orient_default: "默认",
    orient_landscape: "横向 (16:9)",
    orient_portrait: "竖向 (9:16)",
    copied_title: "✓ 提示词已复制！",
    copied_desc: "打开 AI 工具并上传您的照片：",
    copied_tip: "提示：先上传您的照片，然后粘贴复制的提示词。",
  },

  // ─────────────────────────── TAMIL ───────────────────────────
  ta: {
    hero_badge: "கிளிக் · தானியங்கி நகல் · எங்கும் ஒட்டு",
    hero_title_1: "ஒரு பாணியைத் தேர்ந்தெடுக்கவும்.",
    hero_title_2: "ப்ராம்ப்ட் உடனடியாக நகலெடுக்கப்பட்டது.",
    hero_subtitle: "எந்த பாணியையும் கிளிக் செய்யவும் — ப்ராம்ப்ட் தானாகவே கிளிப்போர்டுக்கு நகலெடுக்கப்படும். உங்கள் புகைப்படத்துடன் Gemini, ChatGPT அல்லது எந்த AI கருவியிலும் ஒட்டவும்.",
    search_placeholder: "பாணிகளைத் தேடு...",
    styles_available: "{n} பாணிகள் கிடைக்கின்றன",
    click_to_copy: "ப்ராம்ப்ட் நகலெடுக்க கிளிக் செய்க",
    login_to_copy: "நகலெடுக்க உள்நுழைக",
    no_styles: '"{search}" க்கான பாணிகள் இல்லை',
    how_to_use: "எப்படி பயன்படுத்துவது",
    step_label: "படி",
    step1_title: "உள்நுழைக",        step1_desc: "தொடங்க உங்கள் Google கணக்கில் உள்நுழையவும்",
    step2_title: "பாணியைத் தேர்வு செய்க", step2_desc: "நீங்கள் விரும்பும் கலை பாணியை உலாவி கண்டறியவும்",
    step3_title: "கிளிக் — தானியங்கி நகல்", step3_desc: "ப்ராம்ப்ட் உடனடியாக உங்கள் கிளிப்போர்டுக்கு நகலெடுக்கப்படும்",
    step4_title: "பதிவேற்று & ஒட்டு", step4_desc: "உங்கள் புகைப்படத்தைப் பதிவேற்றி எந்த AI கருவியிலும் ஒட்டவும்",
    counter_left: "{left} / {limit} மீதம்",
    upgrade_arrow: "மேம்படுத்து →",
    modal_title: "மேலும் ப்ராம்ப்ட்கள் பெறுங்கள்",
    modal_subtitle: "ஒரு முறை கட்டணம். சந்தா இல்லை. காலாவதி இல்லை.",
    tier_starter: "ஸ்டார்ட்டர்",
    tier_popular: "பாப்புலர்",
    tier_lifetime: "லைஃப்டைம்",
    starter_value: "20 ப்ராம்ப்ட்கள்",
    popular_value: "100 ப்ராம்ப்ட்கள்",
    lifetime_value: "∞ வரம்பற்ற ப்ராம்ப்ட்கள்",
    valid_30days: "30 நாட்களுக்கு செல்லுபடியாகும்",
    lifetime_sub: "காலாவதி இல்லை · ஒரு முறை மட்டும்",
    one_time: "ஒரு முறை",
    forever: "என்றென்றும்",
    badge_popular: "மிகவும் பிரபலமான",
    badge_best: "சிறந்த மதிப்பு",
    modal_note: "உங்கள் படைப்பாற்றலை வெளிப்படுத்துங்கள். எப்போது வேண்டுமானாலும் ப்ராம்ப்ட்களைப் பயன்படுத்தி எந்த புகைப்படத்தையும் அழகிய கலையாக மாற்றுங்கள்.",
    maybe_later: "பிறகு பார்க்கலாம்",
    login_first: "ப்ராம்ப்ட்களை நகலெடுக்க முதலில் உள்நுழையவும்.",
    suggest_title: "ஒரு பாணியை பரிந்துரைக்கவும்",
    suggest_desc: "எங்களிடம் இல்லாத பாணி வேண்டுமா? எங்களிடம் சொல்லுங்கள் — உங்கள் யோசனைகளின் அடிப்படையில் புதிய பாணிகளைச் சேர்க்கிறோம்.",
    suggest_placeholder: "எ.கா. 'கார்ட்டூன் கேரிகேச்சர்' பாணியைச் சேர்க்கவும், அல்லது ஏதேனும் கருத்து...",
    suggest_send: "பரிந்துரையை அனுப்பு",
    suggest_sending: "அனுப்புகிறது...",
    suggest_success: "✓ நன்றி! உங்கள் பரிந்துரை அனுப்பப்பட்டது.",
    suggest_login: "பரிந்துரையை அனுப்ப உள்நுழையவும்.",
    suggest_error: "ஏதோ தவறு நடந்தது. மீண்டும் முயற்சிக்கவும்.",
    cat_all: "அனைத்தும்", cat_comic: "காமிக்", cat_cute: "அழகான", cat_animation: "அனிமேஷன்",
    cat_traditional: "பாரம்பரிய", cat_digital: "டிஜிட்டல்", cat_retro: "ரெட்ரோ",
    cat_art: "கலை", cat_minimal: "எளிமை",
    orient_default: "இயல்பு",
    orient_landscape: "நிலப்படம் (16:9)",
    orient_portrait: "உருவப்படம் (9:16)",
    copied_title: "✓ ப்ராம்ப்ட் நகலெடுக்கப்பட்டது!",
    copied_desc: "AI கருவியைத் திறந்து உங்கள் புகைப்படத்தை பதிவேற்றவும்:",
    copied_tip: "குறிப்பு: முதலில் உங்கள் புகைப்படத்தை பதிவேற்றவும், பின்னர் நகலெடுத்த prompt ஐ ஒட்டவும்.",
  },
};